var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { FA_CHEVRON_RIGHT } from '../../../const/iconProps';
import { ENTER_KEY, SPACE_KEY } from '../../../const/keyNames';
import ScreenReaderText from '../../atoms/ScreenReaderText';
import useWindowWidth from '../../customHooks/useWindowWidth';
import { Inset } from '../../spacing';
import { Small } from '../../typography';
import { Badge, BodyWrapper, FlexWrapper, LeftIconWrapper, NotificationRibbon, RightIconWrapper } from './subcomponents';
const NotificationBar = (_a, ref) => {
    var { type, title, icon, className, onClickHandler, isTruncated, notificationCount, notificationCountLabel, subTitle, label, dataType, forceIsClickable = false } = _a, props = __rest(_a, ["type", "title", "icon", "className", "onClickHandler", "isTruncated", "notificationCount", "notificationCountLabel", "subTitle", "label", "dataType", "forceIsClickable"]);
    const [isEllipseActive, setIsEllipseActive] = useState(null);
    const windowRef = useRef(null);
    const windowWidth = useWindowWidth();
    const isNotificationCountVisible = notificationCount > 1;
    const isClickable = isEllipseActive || isNotificationCountVisible || forceIsClickable;
    const hasSubTitle = !!(subTitle === null || subTitle === void 0 ? void 0 : subTitle.length);
    const onKeyDownHandler = (e) => {
        if (e.key === ENTER_KEY || e.key === SPACE_KEY) {
            onClickHandler();
        }
    };
    const dynamicNotificationProps = isClickable && {
        role: 'button',
        onClick: onClickHandler,
        tabIndex: 0,
        onKeyDown: onKeyDownHandler
    };
    useEffect(() => {
        var _a, _b;
        const checkEllipse = () => {
            if (windowRef === null || windowRef === void 0 ? void 0 : windowRef.current) {
                const { offsetWidth, scrollWidth } = windowRef.current;
                setIsEllipseActive(offsetWidth < scrollWidth);
            }
        };
        if (document === null || document === void 0 ? void 0 : document.fonts) {
            (_b = (_a = document === null || document === void 0 ? void 0 : document.fonts) === null || _a === void 0 ? void 0 : _a.ready) === null || _b === void 0 ? void 0 : _b.then(() => {
                requestAnimationFrame(checkEllipse);
            });
        }
        else {
            requestAnimationFrame(checkEllipse);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowWidth.width, title]);
    return (_jsx(NotificationRibbon, Object.assign({ "aria-label": label, type: type, isClickable: isClickable, className: className }, dynamicNotificationProps, props, { ref: ref }, { children: _jsxs(Inset, Object.assign({ horizontal: "small", vertical: "base" }, { children: [_jsxs(FlexWrapper, { children: [icon && (_jsx(Inset, Object.assign({ right: "small" }, { children: _jsx(LeftIconWrapper, Object.assign({ type: type }, { children: icon })) }))), _jsx(BodyWrapper, Object.assign({ isTruncated: isTruncated, ref: windowRef }, { children: title })), isNotificationCountVisible && (_jsx(Badge, Object.assign({ type: type }, { children: _jsxs(Small, Object.assign({ weight: "semiBold" }, { children: [notificationCount, _jsx(ScreenReaderText, { children: notificationCountLabel || 'Notifications' })] })) }))), isClickable && (_jsx(RightIconWrapper, Object.assign({ left: "small", right: "xsmall", type: type }, { children: _jsx(FontAwesomeIcon, { icon: FA_CHEVRON_RIGHT, "data-testid": "chevron", "data-type": dataType, "data-reason": "Expand notification", "data-object": "button", "data-analytics": "clicktrackingevent" }) })))] }), hasSubTitle && (_jsx(Inset, Object.assign({ left: "xlarge" }, { children: _jsx(BodyWrapper, Object.assign({ hasSubTitle: true, isTruncated: isTruncated }, { children: subTitle })) })))] })) })));
};
export default forwardRef(NotificationBar);
//# sourceMappingURL=NotificationBar.js.map